import { useState } from "react";
import { ImageBroken } from "@phosphor-icons/react";

// Robust set thumbnail with fallback. BrickLink CDN is sometimes unreachable
// (DNS / region issues), so we always fall back gracefully to a placeholder
// icon when the image fails to load.
export default function SetThumb({ src, alt, size = 28, className = "" }) {
  const [errored, setErrored] = useState(false);
  const px = `${size}px`;
  const cls = `flex-shrink-0 object-contain bg-[#F6F6F3] rounded-sm border border-[#E4E4E0] ${className}`;
  if (!src || errored) {
    return (
      <div style={{ width: px, height: px }} className={`${cls} flex items-center justify-center`}>
        <ImageBroken size={Math.floor(size * 0.5)} className="text-gray-400" />
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt || ""}
      style={{ width: px, height: px }}
      className={cls}
      onError={() => setErrored(true)}
      loading="lazy"
    />
  );
}
